import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";
import CommonService from "@/commons/services/CommonService";
import RegionMastersService, { RegionMastersGetModel } from "@/commons/services/RegionMasters";
import LoginUser from "./LoginUser";

/** store state model */
export interface RegionsState {
  /** 地域情報 */
  regions: Array<RegionMastersGetModel>;
}

/**
 * ### Regions store
 *
 * - store
 *   - システム情報を保持する
 * - action, mutation
 *   - システム情報を設定する
 */
@Module({ name: "regions" })
export default class Regions extends VuexModule implements RegionsState {
  regions: Array<RegionMastersGetModel> = [];

  @Mutation
  private SET_REGIONS(regions: Array<RegionMastersGetModel>): void {
    this.regions = regions;
    return;
  }

  @Action({ rawError: true })
  public async init(payload: { userStore: LoginUser }): Promise<void> {
    try {
      const commonService: CommonService = new CommonService();
      const regionMastersService: RegionMastersService = new RegionMastersService(commonService);
      const response: Array<RegionMastersGetModel> = await regionMastersService.gets(payload.userStore);

      this.SET_REGIONS(response);

      return;
    } catch (error) {
      console.error(error);
    }
  }
}
